export const DEFAULT_MENU_SETTINGS = {
  headerLinks: [],
  footerLinks: []
};

export const normalizeMenuLink = (link = {}) => ({
  label: String(link.label || '').trim(),
  url: String(link.url || '').trim(),
  enabled: link.enabled !== false,
  openInNewTab: link.openInNewTab === true
});

export const normalizeMenuSettings = (raw = {}) => ({
  headerLinks: (Array.isArray(raw?.headerLinks) ? raw.headerLinks : [])
    .slice(0, 8)
    .map(normalizeMenuLink)
    .filter((link) => link.label && link.url),
  footerLinks: (Array.isArray(raw?.footerLinks) ? raw.footerLinks : [])
    .slice(0, 12)
    .map(normalizeMenuLink)
    .filter((link) => link.label && link.url)
});

export const getActiveMenuLinks = (menus, section = 'headerLinks') => {
  const settings = normalizeMenuSettings(menus);
  return settings[section].filter((link) => link.enabled);
};

export const isExternalUrl = (url) => /^https?:\/\//i.test(url);
